/**
 * Pending Orders Hook
 * @see Sprint 28 - US-28.5
 */

import { useQuery } from '@tanstack/react-query';
import { dashboardService } from '../services/dashboard.service';
import { dashboardKeys } from './useDashboardData';

export function usePendingOrders() {
  return useQuery({
    queryKey: [...dashboardKeys.all, 'pendingOrders'] as const,
    queryFn: () => dashboardService.getPendingOrders(),
    staleTime: 2 * 60 * 1000,
    placeholderData: (prev) => prev,
  });
}
